import { render, staticRenderFns } from "./DocFAQLink.vue?vue&type=template&id=7f6a5c44"
import script from "./DocFAQLink.ts?vue&type=script&lang=ts&external"
export * from "./DocFAQLink.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports